import React from 'react';
import './MapItem.css';
import { MapData } from '../types';

interface MapItemProps {
  map: MapData;
  onVeto: (mapId: number) => void;
  disabled: boolean;
}

const MapItem: React.FC<MapItemProps> = ({ map, onVeto, disabled }) => {
  const handleClick = (): void => {
    if (!disabled) {
      onVeto(map.id);
    }
  };

  return (
    <div 
      className={`map-item ${map.status === 'banned' ? 'banned' : ''}`}
      onClick={handleClick}
    >
      <div className="map-image-container">
        <img src={map.image} alt={map.name} className="map-image" />
        {map.status === 'banned' && <div className="banned-overlay">BANNED</div>}
      </div>
      <div className="map-name">{map.name}</div>
    </div>
  );
};

export default MapItem;